import MovieBanner from "../components/moviebanner/MovieBanner"
import { useState } from "react"
import '../components/detailbutton/DetailButton.css'
import Detail from "../components/detail/detail"
import Tabs from '../components/tabs/tabs'
const DetailPage = () => {
    const [detail, setDetail] = useState('')

    return (
        <div>
            <MovieBanner />
            {/* <div className='container'>
                <div className='detail-wrapper'>
                    <div className='title' onClick={() => setDetail('')}>Overview</div>
                    <div className='title' onClick={() => setDetail('Cast')}>Character</div>
                    <div className='title' onClick={() => setDetail('Review')}>Review</div>
                </div>
            </div>
            <Detail detail={detail} /> */}
            <Tabs />
            
        </div>
    )
}

export default DetailPage;